import React, { useEffect, useState } from 'react';
import { useOutletContext } from "react-router-dom";
import "./TeacherDirectory.css";
import Teacher from "../components/Teacher";
import { hodInfo, teacherList } from "../components/TeacherList";
import { Grid } from "@mui/material";

const TeacherDirectory = React.memo(() => {
  const [hodIsLoaded, setHodIsLoaded] = useState(false);

  // Get the setContentLoaded function from the outlet context (with a fallback)
  const outletContext = useOutletContext() || {};
  const setContentLoaded = outletContext.setContentLoaded || (() => {});

  const handleImageLoad = () => {
    setHodIsLoaded(true);
    // Signal that the page is loaded so the footer can appear.
    setContentLoaded(true);
  };

  return (
    <div className='teachersPage'>
      <h1 className='languageDepartmentLabel'>Language Department Teachers</h1>

      <div className='languageTeachersPage'>
        <div className="departmentHod">
          <img
            src={hodInfo[0].image}
            alt="Mrs. Denise Aguilar"
            className='hodImage'
            onLoad={handleImageLoad}
          />

          <div className='teacherDetail'>
            <h3 className='hodName'>{hodInfo[0].teacherName}</h3>
            <div className='hodLabel'>Head of Department</div>
            <p>
              Email: <span style={{ color: '#02004e', fontWeight: "bold" }}>
                {hodInfo[0].email}
              </span>
            </p>
            <p className='engSubjects'>
              {hodInfo[0].subjects.join(' / ')}
            </p>
          </div>
        </div>

        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          {teacherList.slice(0, 9).map((teacher, index) => (
            <Grid item xs={2} sm={4} md={4} key={index}>
              <Teacher key={index} teacher={teacher} index={index} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
});

export default TeacherDirectory;
